export const SELECT_PLAYER = 'SELECT_PLAYER';

export const ScorerSpeed = 150
export const RefereeSpeed = 100
export const WalkSpeed = 60
export const BrownianSpeed = 10;


/** WEBPACK FOOTER **
 ** ./src/components/Animations/Scenes/Constants.js
 **/